import { useTranslation } from "react-i18next";

/**
 * 上传框内的可见提示：告知可拖拽或粘贴图片。
 * 仅用于尺寸够大的上传框（≥175px 或留白区）；小框靠 useImageUploadZone 的
 * `title` hover tooltip。文案复用 `common.uploadZoneHint`，与 tooltip 保持一致。
 */
export function UploadZoneHint() {
  const { t } = useTranslation();
  return (
    <span
      style={{
        fontSize: "0.62rem",
        color: "var(--text-3)",
        textAlign: "center",
        lineHeight: 1.2,
        marginTop: "2px",
      }}
    >
      {t("uploadZoneHint", { ns: "common" })}
    </span>
  );
}
